/**
 * Database Types — Supabase Tabellen-Typen
 * Generiert aus dem Schema der Gutachter KOOP Datenbank
 * Erweitert: Betriebe, Rechnungspositionen, Zahlungseingänge, DATEV, Honorartabelle
 */

export interface Database {
  public: {
    Tables: {
      mitarbeiter: {
        Row: Mitarbeiter;
        Insert: Omit<Mitarbeiter, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Mitarbeiter, 'id'>>;
      };
      kunden: {
        Row: Kunde;
        Insert: Omit<Kunde, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Kunde, 'id'>>;
      };
      akten: {
        Row: Akte;
        Insert: Omit<Akte, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Akte, 'id'>>;
      };
      aufgaben: {
        Row: Aufgabe;
        Insert: Omit<Aufgabe, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Aufgabe, 'id'>>;
      };
      termine: {
        Row: Termin;
        Insert: Omit<Termin, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Termin, 'id'>>;
      };
      rechnungen: {
        Row: Rechnung;
        Insert: Omit<Rechnung, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Rechnung, 'id'>>;
      };
      dokumente: {
        Row: Dokument;
        Insert: Omit<Dokument, 'id' | 'created_at'>;
        Update: Partial<Omit<Dokument, 'id'>>;
      };
      rechnungspositionen: {
        Row: Rechnungsposition;
        Insert: Omit<Rechnungsposition, 'id' | 'created_at'>;
        Update: Partial<Omit<Rechnungsposition, 'id'>>;
      };
      auslagen: {
        Row: Auslage;
        Insert: Omit<Auslage, 'id' | 'mwst_betrag' | 'betrag_brutto' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Auslage, 'id' | 'mwst_betrag' | 'betrag_brutto'>>;
      };
      betriebe: {
        Row: BetriebDB;
        Insert: Omit<BetriebDB, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<BetriebDB, 'id'>>;
      };
      zahlungseingaenge: {
        Row: Zahlungseingang;
        Insert: Omit<Zahlungseingang, 'id' | 'created_at'>;
        Update: Partial<Omit<Zahlungseingang, 'id'>>;
      };
      datev_exporte: {
        Row: DatevExport;
        Insert: Omit<DatevExport, 'id' | 'created_at'>;
        Update: Partial<Omit<DatevExport, 'id'>>;
      };
      honorartabelle: {
        Row: Honorar;
        Insert: Omit<Honorar, 'id' | 'created_at'>;
        Update: Partial<Omit<Honorar, 'id'>>;
      };
      eingangsbelege: {
        Row: Eingangsbeleg;
        Insert: Omit<Eingangsbeleg, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Eingangsbeleg, 'id'>>;
      };
      buchungsvorschlaege: {
        Row: Buchungsvorschlag;
        Insert: Omit<Buchungsvorschlag, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Buchungsvorschlag, 'id'>>;
      };
      ueberweisungen: {
        Row: Ueberweisung;
        Insert: Omit<Ueberweisung, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Ueberweisung, 'id'>>;
      };
      verpflegung_belege: {
        Row: VerpflegungBeleg;
        Insert: Omit<VerpflegungBeleg, 'id' | 'created_at'>;
        Update: Partial<Omit<VerpflegungBeleg, 'id'>>;
      };
      verpflegung_verzehr: {
        Row: VerpflegungVerzehr;
        Insert: Omit<VerpflegungVerzehr, 'id' | 'created_at'>;
        Update: Partial<Omit<VerpflegungVerzehr, 'id'>>;
      };
      kunden_links: {
        Row: KundenLink;
        Insert: Omit<KundenLink, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<KundenLink, 'id'>>;
      };
      kunden_link_dokumente: {
        Row: KundenLinkDokument;
        Insert: Omit<KundenLinkDokument, 'id' | 'created_at'>;
        Update: Partial<Omit<KundenLinkDokument, 'id'>>;
      };
      kanzleien: {
        Row: Kanzlei;
        Insert: Omit<Kanzlei, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Kanzlei, 'id'>>;
      };
      honorarvereinbarung_templates: {
        Row: HonorarvereinbarungTemplate;
        Insert: Omit<HonorarvereinbarungTemplate, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<HonorarvereinbarungTemplate, 'id'>>;
      };
      marken: {
        Row: Marke;
        Insert: Omit<Marke, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Marke, 'id'>>;
      };
      pool_reservierungen: {
        Row: PoolReservierung;
        Insert: Omit<PoolReservierung, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<PoolReservierung, 'id'>>;
      };
      fahrtenbuch_eintraege: {
        Row: FahrtenbuchEintrag;
        Insert: Omit<FahrtenbuchEintrag, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<FahrtenbuchEintrag, 'id'>>;
      };
      nutzungsordnung_bestaetigungen: {
        Row: NutzungsordnungBestaetigung;
        Insert: Omit<NutzungsordnungBestaetigung, 'id' | 'created_at'>;
        Update: Partial<Omit<NutzungsordnungBestaetigung, 'id'>>;
      };
      crm_kontakt_labels: {
        Row: CrmKontaktLabel;
        Insert: Omit<CrmKontaktLabel, 'id' | 'created_at'>;
        Update: Partial<Omit<CrmKontaktLabel, 'id'>>;
      };
      crm_kontakt_notizen: {
        Row: CrmKontaktNotiz;
        Insert: Omit<CrmKontaktNotiz, 'id' | 'created_at'>;
        Update: Partial<Omit<CrmKontaktNotiz, 'id'>>;
      };
      nummernkreise: {
        Row: Nummernkreis;
        Insert: Omit<Nummernkreis, 'id' | 'created_at'>;
        Update: Partial<Omit<Nummernkreis, 'id'>>;
      };
      akten_fristen: {
        Row: AkteFrist;
        Insert: AkteFristInsert;
        Update: AkteFristUpdate;
      };
      ladekostenzuschuss: {
        Row: Ladekostenzuschuss;
        Insert: Omit<Ladekostenzuschuss, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Ladekostenzuschuss, 'id'>>;
      };
    };
  };
}

export interface Mitarbeiter {
  id: string;
  vorname: string;
  nachname: string;
  email: string;
  telefon: string | null;
  rolle: string;
  business_units: string[];
  avatar_url: string | null;
  ist_aktiv: boolean;
  created_at: string;
  updated_at: string;
}

export interface Kunde {
  id: string;
  anrede: string | null;
  vorname: string;
  nachname: string;
  firma: string | null;
  email: string | null;
  telefon: string | null;
  mobil: string | null;
  strasse: string | null;
  plz: string | null;
  ort: string | null;
  notizen: string | null;
  business_units: string[];
  created_at: string;
  updated_at: string;
}

export interface Akte {
  id: string;
  // Legacy, nullable copy of the authoritative `akten_nummer`. Always read via
  // the `aktenIdentifier` helper (prefers `akten_nummer`, falls back to
  // `akten_nr`) — see issue #155.
  akten_nr: string | null;
  akten_nummer: string;
  business_unit: string;
  kunde_id: string | null;
  bearbeiter_id: string | null;
  titel: string;
  beschreibung: string | null;
  status: string;
  prioritaet: string;
  // Direkte Kundendaten (denormalisiert)
  kunde_name: string | null;
  kunde_telefon: string | null;
  kunde_email: string | null;
  // Fahrzeugdaten
  fahrzeug_kennzeichen: string | null;
  kennzeichen: string | null;
  fahrzeug_marke: string | null;
  fahrzeug_modell: string | null;
  fahrzeug_baujahr: number | null;
  fahrzeug_vin: string | null;
  fahrzeug_id: string | null;
  // Schadendaten
  schadennummer: string | null;
  versicherung: string | null;
  schadenart: string | null;
  schadendatum: string | null;
  besichtigungsdatum: string | null;
  // Autoglas
  glasart: string | null;
  glasposition: string | null;
  // Mietwagen
  mietbeginn: string | null;
  mietende: string | null;
  tagespreis: number | null;
  // Fachlicher Lebenszyklus der Mietwagen-Akte (Issue #425)
  mietwagen_status?: 'vertrag_offen' | 'uebergeben' | 'in_miete' | 'zurueckgegeben' | 'abgerechnet' | 'abgeschlossen' | null;
  unterschrift_anfrage_datum?: string | null;
  // Finanzen
  auftragsart: string | null;
  kostenvoranschlag: number | null;
  gesamtbetrag: number | null;
  notizen: string | null;
  // SV-Büro Gutachten-Felder
  auftragstyp_sv: string | null;
  status_sv: string | null;
  fin: string | null;
  auftragsdatum: string | null;
  schadentag: string | null;
  schadenort: string | null;
  schadenort_strasse: string | null;
  versicherungsnummer: string | null;
  kennzeichen_gegner: string | null;
  wiederbeschaffungswert: number | null;
  reparaturkosten_netto: number | null;
  reparaturkosten_brutto: number | null;
  restwert: number | null;
  minderwert: number | null;
  wiederbeschaffungswert_netto?: number | null;
  ersatzteilkosten_netto?: number | null;
  lohnkosten_netto?: number | null;
  lackkosten_netto?: number | null;
  zusatzkosten_netto?: number | null;
  // Gutachten-Honorar und Nebenkosten (SV-Büro)
  sv_honorar_netto?: number | null;
  nebenkosten?: number | null;
  merkantile_wertminderung?: number | null;
  nutzungsausfall_betrag: number | null;
  mwst_satz: number | null;
  erteilt_durch: string | null;
  vermittelt_durch: string | null;
  // Timestamps
  erstellt_am: string | null;
  aktualisiert_am: string | null;
  erstellt_von: string | null;
  created_at: string;
  updated_at: string;
  // Mehrfach-Labels auf Aktenebene (z. B. "Stellungnahme") — Issue #240
  labels?: string[] | null;
  // Unterschrift / Auftragserteilung
  unterschrift_data?: string | null;
  unterschrift_datum?: string | null;
  auftrag_pdf_url?: string | null;
  auftrag_unterzeichnet?: boolean | null;
  // Marketing / Social Media (aus kunden-Tabelle, denormalisiert)
  instagram_einwilligung?: boolean | null;
  instagram_handle?: string | null;
  bewertung_angefragt?: boolean | null;
  bewertung_bestaetigt?: boolean | null;
  tankgutschein_vergeben?: boolean | null;
  // WinValue-Referenz
  winvalue_uid?: string | null;
  winvalue_ref?: string | null;
  winvalue_last_sync?: string | null;
  winvalue_url?: string | null;
  winvalue_internal_id?: string | null;
  winvalue_documents_count?: number | null;
  // Versicherung (Gegner) — erweitert
  versicherung_email?: string | null;
  versicherung_telefon?: string | null;
  versicherung_adresse?: string | null;
  versicherung_plz?: string | null;
  versicherung_ort?: string | null;
  versicherung_fax?: string | null;
  // Anspruchsteller
  anspruchsteller_name?: string | null;
  anspruchsteller_strasse?: string | null;
  anspruchsteller_adresse?: string | null;
  anspruchsteller_plz?: string | null;
  anspruchsteller_ort?: string | null;
  anspruchsteller_telefon?: string | null;
  anspruchsteller_email?: string | null;
  anspruchsteller_geburtsdatum?: string | null;
  // Fahrer
  fahrer_name?: string | null;
  fahrer_strasse?: string | null;
  fahrer_adresse?: string | null;
  fahrer_plz?: string | null;
  fahrer_ort?: string | null;
  fahrer_telefon?: string | null;
  fahrer_email?: string | null;
  fahrer_fuehrerschein_nr?: string | null;
  fahrer_geburtsdatum?: string | null;
  fahrer_ist_anspruchsteller?: boolean | null;
  // Gegner
  gegner_name?: string | null;
  gegner_adresse?: string | null;
  gegner_plz?: string | null;
  gegner_ort?: string | null;
  // Unfalldaten
  unfalldatum?: string | null;
  unfallort?: string | null;
  unfallhergang?: string | null;
  polizei_aufgenommen?: boolean | null;
  polizei_aktenzeichen?: string | null;
  // Fahrzeug (erweitert)
  fahrzeug_submodell?: string | null;
  fahrzeug_hsn?: string | null;
  fahrzeug_tsn?: string | null;
  fahrzeug_ez?: string | null;
  fahrzeug_km?: number | null;
  fahrzeug_farbe?: string | null;
  fahrzeug_kw?: number | null;
  fahrzeug_ccm?: number | null;
  fahrzeug_hu?: string | null;
  fahrzeug_bauart?: string | null;
  fahrzeug_fahrbereit?: boolean | null;
  fahrzeug_totalschaden?: boolean | null;
  fahrzeug_standort?: string | null;
  fahrzeug_klasse?: string | null;
  // Mietfahrzeug
  mietfahrzeug_kennzeichen?: string | null;
  mietfahrzeug_marke?: string | null;
  mietfahrzeug_modell?: string | null;
  mietfahrzeug_klasse?: string | null;
  mietfahrzeug_km_start?: number | null;
  mietfahrzeug_km_ende?: number | null;
  mietfahrzeug_tankstand_start?: string | null;
  mietfahrzeug_tankstand_ende?: string | null;
  // Übergabe
  uebergabe_datum?: string | null;
  uebergabe_ort?: string | null;
  uebergabe_protokoll_url?: string | null;
  uebergabe_fotos_url?: string | null;
  // Rückgabe
  rueckgabe_datum?: string | null;
  rueckgabe_ort?: string | null;
  rueckgabe_protokoll_url?: string | null;
  rueckgabe_fotos_url?: string | null;
  rueckgabe_schaeden?: string | null;
  rueckgabe_unterschrift_person?: string | null;
  // Mietdauer & Kosten
  mietdauer_tage?: number | null;
  eigenersparnis_tag?: number | null;
  // Mietwagen Wizard Felder (Issue #611)
  mietbeginn_uhrzeit?: string | null;
  mietende_uhrzeit?: string | null;
  kaution_betrag?: number | null;
  zahlart?: 'bar' | 'ec_karte' | 'kreditkarte' | 'ueberweisung' | 'abtretung' | null;
  zahlbetrag_erhalten?: number | null;
  km_inklusive_pauschale?: number | null;
  mehr_km_preis?: number | null;
  versicherungs_paket?: 'vollkasko_500sb' | 'vollkasko_1000sb' | 'teilkasko' | 'ohne' | null;
  insassen_unfallversicherung?: boolean | null;
  vorhandene_schaeden_uebergabe?: string | null;
  uebergabe_fotos_urls?: string[] | null;
  vertragsnummer?: string | null;
  eigenersparnis_gesamt?: number | null;
  klassengleichheit?: boolean | null;
  selbstbeteiligung?: number | null;
  haftungsquote?: number | null;
  // Abtretung
  abtretung_status?: string | null;
  abtretung_datum?: string | null;
  abtretung_unterschrift_url?: string | null;
  // Rechnung
  rechnung_nr?: string | null;
  rechnung_datum?: string | null;
  rechnung_betrag?: number | null;
  rechnung_pdf_url?: string | null;
  rechnung_bezahlt?: boolean | null;
  rechnung_bezahlt_am?: string | null;
  rechnung_bezahlt_betrag?: number | null;
  rechnung_festgeschrieben?: boolean | null;
  kuerzung_betrag?: number | null;
  kuerzung_grund?: string | null;
  // Gutachten-Referenz
  gutachten_aktenzeichen?: string | null;
  gutachten_sv?: string | null;
  // Anwalt
  anwalt_name?: string | null;
  anwalt_telefon?: string | null;
  anwalt_email?: string | null;
  anwalt_aktenzeichen?: string | null;
  anwalt_adresse?: string | null;
  anwalt_plz?: string | null;
  anwalt_ort?: string | null;
  // Werkstatt
  werkstatt_name?: string | null;
  werkstatt_telefon?: string | null;
  werkstatt_email?: string | null;
  werkstatt_adresse?: string | null;
  werkstatt_plz?: string | null;
  werkstatt_ort?: string | null;
  reparaturdauer_tage?: number | null;
  voraussichtliche_reparaturdauer?: number | null;
  // Stellungnahme (Issue #243)
  stellungnahme_status?: string | null; // 'offen' | 'versendet' | 'abgerechnet' | null
  schriftsatzfrist?: string | null;     // ISO date (YYYY-MM-DD) — Schriftsatzfrist des Gerichts
  // Prüfungs-QS-Workflow (Issue #463)
  pruefung_status?: 'keine' | 'qs_erforderlich' | 'qs_in_arbeit' | 'qs_korrektur' | 'qs_freigegeben' | null;
  pruefung_zugewiesen_an?: string | null; // UUID → mitarbeiter, nullable
  // Hauptphase-Workflow (Issue #414)
  hauptphase?: number | null;           // 1..6
  hauptphase_datum?: string | null;
  zahlungsstatus?: string | null;
  klage_status?: string | null;
  warten_auf?: string | null;
  // Honorarvereinbarung (Issue #373) — FK auf honorarvereinbarung_templates
  honorarvereinbarung_template_id?: string | null;
  // Honorar-Basis-Version (Issue #371) — Tarif-Version pro Akte; BVSK_2026 ist Standard
  honorar_basis_version?: 'BVSK_2026' | 'BVSK_2024' | 'HUK' | 'custom' | null;
  // Mietwagen Prozess-Felder
  zerlegungsdauer_tage?: number | null;
  mietdauer_begruendung?: string | null;
  fahrzeug_verkehrssicher?: boolean | null;
  notreparatur_moeglich?: boolean | null;
  schadenscheck_ergebnis?: string | null;
  schadenscheck_kosten?: number | null;
  schadenscheck_notizen?: string | null;
  // Pool-Reservierungs-Referenz (Issue #167)
  pool_reservierung_id?: string | null;
  schaden_foto_urls?: string[] | null;
  // Cross-Link Gutachten ↔ Mietwagen (Issue #272)
  mietwagen_in_anspruch?: boolean | null;
  mietwagen_akte_id?: string | null;
  // Cross-Link Gutachten ↔ Werkstatt (Issue #328)
  werkstatt_in_anspruch?: boolean | null;
  werkstatt_akte_id?: string | null;
  werkstatt_auto_match_kandidaten?: WerkstattAutoMatchKandidat[] | null;
  // Werkstatt-Akte aus Gutachten: Demontage + Rückverweis (Issue #587)
  demontage_erforderlich?: boolean | null;
  gutachten_akte_id?: string | null;
  // Werkstatt-Akte Status-Kette (Issue #588, Migration 20260425)
  werkstatt_status?: string | null;
  // Bidirektionaler Cross-Link (generisch, älteres Feld)
  linked_akte_id?: string | null;
  // Forderungsmanager — verknüpfte Forderungsakte (Issue #598)
  forderungsakte_id?: string | null;
  forderung_stage?: number | null;       // 0–9, von forderungsakten.stage (Issue #562)
  // SV-Büro Rechnung / WinValue-Sync (Issue #842)
  rechnungsdatum?: string | null;
  rechnung_status?: string | null;
  auslagen?: number | null;
  besichtigt_durch?: string | null;
  // Akten-Ersteller (Issue #800 Migration + Issue #802 Frontend)
  created_by_mitarbeiter_id?: string | null;
  created_via?: 'manuell' | 'winvalue_sync' | 'kiosk' | 'mcp' | 'email_import' | 'api' | 'csv_import' | null;
  // Joined relations (optional, from select queries)
  kunden?: { vorname: string; nachname: string } | null;
  mitarbeiter?: { vorname: string; nachname: string } | null;
  creator_mitarbeiter?: { vorname: string; nachname: string } | null;
}

export interface Aufgabe {
  id: string;
  business_unit: string;
  akte_id: string | null;
  termin_id: string | null;
  zugewiesen_an: string | null;
  zugewiesen_an_liste: string[];
  erstellt_von: string | null;
  titel: string;
  beschreibung: string | null;
  status: string;
  prioritaet: string;
  kategorie: string | null;
  faellig_am: string | null;
  erledigt_am: string | null;
  checkliste: ChecklistItem[] | null;
  wiedervorlage_datum: string | null;
  wiedervorlage_notiz: string | null;
  // Wiederkehrende Aufgaben
  wiederholung_typ: WiederholungTyp | null;
  wiederholung_intervall: number | null;
  wiederholung_wochentage: number[] | null;
  wiederholung_ende: string | null;
  naechste_faelligkeit: string | null;
  eltern_aufgabe_id: string | null;
  // KI-Agent Felder
  ist_ki_aufgabe: boolean;
  ki_status: string | null;
  ki_feedback: string | null;
  created_at: string;
  updated_at: string;
}

export type WiederholungTyp = 'taeglich' | 'woechentlich' | 'monatlich' | 'jaehrlich' | 'benutzerdefiniert';

export const WIEDERHOLUNG_LABELS: Record<WiederholungTyp, string> = {
  taeglich: 'Täglich',
  woechentlich: 'Wöchentlich',
  monatlich: 'Monatlich',
  jaehrlich: 'Jährlich',
  benutzerdefiniert: 'Benutzerdefiniert',
};

export const WOCHENTAG_LABELS: Record<number, string> = {
  0: 'So',
  1: 'Mo',
  2: 'Di',
  3: 'Mi',
  4: 'Do',
  5: 'Fr',
  6: 'Sa',
};

export interface ChecklistItem {
  id: string;
  text: string;
  done: boolean;
}

// E-Mail-zu-Aufgabe Metadaten (gespeichert als JSON in wiedervorlage_notiz)
export type EmailTyp =
  | 'stellungnahme'      // Prüfbericht/Kürzung von Versicherung → Stellungnahme nötig
  | 'anwalt_anfrage'     // Anwalt schickt Dokumente/Anfrage
  | 'versicherung'       // Allg. Versicherungskorrespondenz
  | 'kunde'              // Kundenanfrage
  | 'werkstatt'          // Werkstatt-bezogen
  | 'mietwagen'          // Mietwagen-bezogen
  | 'autoglas'           // Autoglas-bezogen
  | 'rechnung'           // Rechnungsbezogen
  | 'allgemein';         // Sonstiges

export interface EmailAufgabeMetadata {
  type: 'email_aufgabe';
  messageId: string;
  threadId: string;
  from: string;
  fromName: string;
  subject: string;
  date: string;
  antwortErwartet: boolean;
  antwortFaelligBis?: string;
  anhaenge: EmailAnhang[];
  // NEU: Erweiterte Felder für intelligente E-Mail-Verarbeitung
  emailTyp?: EmailTyp;
  stellungnahmeErforderlich?: boolean;
  aktenverknuepfung?: {
    akteId?: string;
    aktenzeichen?: string;
    winvalueDossierId?: string;
  };
  betrieb?: string; // BetriebId
  autoAntwort?: {
    gesendet: boolean;
    empfaenger?: string;
    text?: string;
  };
}

export interface EmailAnhang {
  filename: string;
  mimeType: string;
  size: number;
  attachmentId?: string;
}

// Helper: EmailMetadata aus wiedervorlage_notiz parsen
export function parseEmailMetadata(notiz: string | null): EmailAufgabeMetadata | null {
  if (!notiz) return null;
  try {
    const data = JSON.parse(notiz);
    if (data?.type === 'email_aufgabe') return data as EmailAufgabeMetadata;
    return null;
  } catch {
    return null;
  }
}

// Helper: EmailMetadata serialisieren
export function serializeEmailMetadata(meta: EmailAufgabeMetadata): string {
  return JSON.stringify(meta);
}

export interface Termin {
  id: string;
  business_unit: string;
  akte_id: string | null;
  mitarbeiter_id: string | null;
  kunde_id: string | null;
  titel: string;
  beschreibung: string | null;
  ort: string | null;
  beginn: string;
  ende: string;
  ganztaegig: boolean;
  erinnerung_minuten: number | null;
  kategorie: string | null;
  created_at: string;
  updated_at: string;
}

export interface Rechnung {
  id: string;
  rechnungs_nr: string;
  business_unit: string;
  betrieb_id: string | null;
  akte_id: string | null;
  kunde_id: string | null;
  betreff: string;
  // Empfänger
  empfaenger_name: string | null;
  empfaenger_firma: string | null;
  empfaenger_strasse: string | null;
  empfaenger_plz: string | null;
  empfaenger_ort: string | null;
  // Beträge
  netto_betrag: number;
  mwst_satz: number;
  mwst_betrag: number;
  brutto_betrag: number;
  bezahlt_betrag: number;
  kuerzung_betrag: number;
  // Status
  status: string;
  // Daten
  rechnungsdatum: string;
  leistungsdatum: string | null;
  faellig_am: string | null;
  bezahlt_am: string | null;
  // Zusatzinfos
  anwalt_name: string | null;
  anwalt_beteiligt: boolean;
  versicherung: string | null;
  schadensnummer: string | null;
  kennzeichen: string | null;
  fahrzeug: string | null;
  notizen: string | null;
  // PDF
  pdf_url: string | null;
  // DATEV
  datev_exportiert: boolean;
  datev_export_datum: string | null;
  datev_buchungskonto: string | null;
  datev_gegenkonto: string | null;
  datev_kostenstelle: string | null;
  // WinValue
  winvalue_dossier_id: string | null;
  winvalue_rechnung_id: string | null;
  // Quelle der Rechnung ('winvalue' | 'stellungnahme' | 'manuell' / null)
  quelle?: string | null;
  // Auslage-Logik (Issue #582 — Werkstatt-Rechnungen über SV-Büro)
  auslage?: boolean | null;
  auslage_traegt_betrieb_id?: string | null;
  erstattung_durch_versicherung?: boolean | null;
  erstattungsbetrag?: number | null;
  erstattung_eingang_datum?: string | null;
  erstattung_zahlungseingang_id?: string | null;
  abrechnungsschreiben_dokument_id?: string | null;
  erstattung_status?: 'offen' | 'teil_erstattet' | 'voll_erstattet' | 'abgewiesen' | null;
  // Timestamps
  created_at: string;
  updated_at: string;
}

export interface Dokument {
  id: string;
  business_unit: string;
  akte_id: string | null;
  name: string;
  dateityp: string | null;
  groesse_bytes: number | null;
  storage_pfad: string | null;
  kategorie: string | null;
  hochgeladen_von: string | null;
  created_at: string;
  // Labels/Tags (z. B. "Stellungnahme") — Issue #240
  tags?: string[] | null;
}

export interface Rechnungsposition {
  id: string;
  rechnung_id: string;
  position_nr: number;
  bezeichnung: string;
  beschreibung: string | null;
  menge: number;
  einheit: string;
  einzelpreis: number;
  mwst_satz: number;
  netto_betrag: number;
  created_at: string;
}

export interface Schadenposition {
  id: string;
  akte_id: string | null;
  position_nr: number;
  bezeichnung: string;
  beschreibung: string | null;
  betrag: number | null;
  created_at: string;
}

export type AuslagenTyp = 'demontage' | 'abschleppen' | 'standzeit' | 'sonstiges';
export type AuslagenStatus = 'erfasst' | 'uebernommen' | 'bezahlt' | 'storniert';

export interface Auslage {
  id: string;
  akte_id: string;
  betrieb_id: string | null;
  typ: AuslagenTyp;
  bezeichnung: string;
  betrag_netto: number;
  mwst_satz: number;
  mwst_betrag: number;
  betrag_brutto: number;
  belegdatum: string;
  beleg_pdf_url: string | null;
  quelle_rechnung_id: string | null;
  uebernommen_in_honorar_position_id: string | null;
  status: AuslagenStatus;
  notizen: string | null;
  created_at: string;
  updated_at: string;
}

export interface BetriebDB {
  id: string;
  name: string;
  typ: string;
  firma: string;
  strasse: string | null;
  plz: string | null;
  ort: string | null;
  telefon: string | null;
  fax: string | null;
  email: string | null;
  website: string | null;
  steuernummer: string | null;
  ust_id: string | null;
  iban: string | null;
  bic: string | null;
  bank: string | null;
  logo_url: string | null;
  briefkopf_html: string | null;
  fusszeile_html: string | null;
  aktiv: boolean;
  deprecated: boolean;
  created_at: string;
  updated_at: string;
}

export interface Zahlungseingang {
  id: string;
  rechnung_id: string | null;
  betrag: number;
  datum: string;
  zahlungsart: string;
  absender: string | null;
  verwendungszweck: string | null;
  iban_absender: string | null;
  status: string;
  notizen: string | null;
  created_at: string;
}

export interface DatevExport {
  id: string;
  export_datum: string;
  zeitraum_von: string;
  zeitraum_bis: string;
  business_unit: string | null;
  anzahl_buchungen: number;
  csv_url: string | null;
  erstellt_von: string | null;
  created_at: string;
}

export interface Honorar {
  id: string;
  schadenshoehe_von: number;
  schadenshoehe_bis: number;
  grundhonorar: number;
  foto_pauschale: number;
  schreibkosten: number;
  fahrtkosten_km: number;
  porto_telefon: number;
  restwert_ermittlung: number;
  wertminderung: number;
  aktiv: boolean;
  created_at: string;
}

// ============================================================
// Buchhaltung & Überweisungen (Issue #49)
// ============================================================

export type EingangsbelegTyp = 'eingangsrechnung' | 'quittung' | 'gutschrift' | 'sonstiges';
export type EingangsbelegStatus = 'neu' | 'geprueft' | 'gebucht' | 'freigegeben' | 'ueberwiesen' | 'abgelehnt';
export type FirmaId = 'gutachter_koop' | 'lcs_gmbh';
export type BuchungsvorschlagStatus = 'vorschlag' | 'akzeptiert' | 'angepasst' | 'abgelehnt' | 'gebucht';
export type UeberweisungStatus = 'entwurf' | 'freigabe_angefordert' | 'freigegeben' | 'ausgefuehrt' | 'fehlgeschlagen' | 'storniert';

// Status der Übermittlung eines Belegs an den Steuerberater (Feature buchhaltung-ein-ort)
export type UebermittlungStatus = 'offen' | 'spaeter' | 'uebermittelt';

export interface Eingangsbeleg {
  id: string;
  beleg_nr: string | null;
  typ: EingangsbelegTyp;
  status: EingangsbelegStatus;
  // Absender
  absender_name: string | null;
  absender_firma: string | null;
  absender_strasse: string | null;
  absender_plz: string | null;
  absender_ort: string | null;
  absender_iban: string | null;
  absender_bic: string | null;
  // Beträge
  netto_betrag: number;
  mwst_satz: number;
  mwst_betrag: number;
  brutto_betrag: number;
  // Firma
  firma: FirmaId;
  // Daten
  belegdatum: string | null;
  eingangsdatum: string | null;
  faellig_am: string | null;
  // Dokument
  dokument_url: string | null;
  // E-Mail-Import
  email_message_id: string | null;
  email_from: string | null;
  email_subject: string | null;
  email_received_at: string | null;
  // Buchhaltung
  buchungskonto: string | null;
  gegenkonto: string | null;
  kostenstelle: string | null;
  verwendungszweck: string | null;
  notizen: string | null;
  // Freigabe
  freigegeben_von: string | null;
  freigegeben_am: string | null;
  freigabe_notiz: string | null;
  // ── Erweiterungen (Feature buchhaltung-ein-ort) — optional/nullable, da je
  //    nach Migrationsstand evtl. noch nicht vorhanden. ──
  // Betrieb / Brücke zum Universal-Eingangskorb
  betrieb_id?: string | null;
  inbox_item_id?: string | null;
  quelle_datei?: string | null;
  kategorie?: string | null;
  // KI-Prüfung
  pruef_ergebnis?: string | null;
  ki_konfidenz?: number | null;
  kategorisiert_am?: string | null;
  marke_id?: string | null;
  // Übermittlung an Steuerberater (monatliche Buchhaltung)
  uebermittlung_status?: UebermittlungStatus | null;
  uebermittelt_am?: string | null;        // ISO date (YYYY-MM-DD)
  uebermittlung_zeitraum?: string | null; // Monat im Format YYYY-MM
  gebucht_beim_stb?: boolean | null;
  gebucht_am?: string | null;             // ISO date (YYYY-MM-DD)
  // Timestamps
  created_at: string;
  updated_at: string;
}

export interface Buchungsvorschlag {
  id: string;
  eingangsbeleg_id: string | null;
  buchungsdatum: string | null;
  soll_konto: string;
  haben_konto: string;
  betrag: number;
  buchungstext: string | null;
  status: BuchungsvorschlagStatus;
  ki_generiert: boolean;
  ki_konfidenz: number | null;
  firma: FirmaId;
  notizen: string | null;
  erstellt_von: string | null;
  created_at: string;
  updated_at: string;
  // Joined relations (optional)
  eingangsbelege?: Eingangsbeleg | null;
}

export interface Ueberweisung {
  id: string;
  eingangsbeleg_id: string | null;
  firma: FirmaId;
  betrieb_id: string | null;
  // Auftraggeber
  auftraggeber_iban: string | null;
  auftraggeber_bic: string | null;
  auftraggeber_name: string | null;
  // Empfänger
  empfaenger_name: string;
  empfaenger_iban: string;
  empfaenger_bic: string | null;
  // Zahlung
  betrag: number;
  verwendungszweck: string | null;
  ausfuehrungsdatum: string | null;
  // Status
  status: UeberweisungStatus;
  // Freigabe
  freigabe_angefordert_von: string | null;
  freigabe_angefordert_am: string | null;
  freigegeben_von: string | null;
  freigegeben_am: string | null;
  freigabe_notiz: string | null;
  // Kommunikation Irina ↔ Andreas + Prüf-/Workflow-Metadaten (DB-Spalten bereits vorhanden)
  kommentar?: string | null;
  pruef_notiz?: string | null;
  erstellt_von?: string | null;
  ausgefuehrt_am?: string | null;
  // finAPI
  finapi_payment_id: string | null;
  finapi_status: string | null;
  // Metadaten
  notizen: string | null;
  created_at: string;
  updated_at: string;
  // Joined relations (optional)
  eingangsbelege?: Eingangsbeleg | null;
}

// Mitarbeiterverpflegung
export type VerpflegungFirma = 'LCS' | 'Koop';
export type VerpflegungBelegStatus = 'erfasst' | 'exportiert';

export interface VerpflegungBeleg {
  id: string;
  created_at: string;
  datum: string;
  firma: VerpflegungFirma;
  betrag_mahlzeiten: number;
  betrag_aufmerksamkeiten: number;
  beleg_url: string | null;
  notizen: string | null;
  hochgeladen_von: string | null;
  status: VerpflegungBelegStatus;
}

export interface VerpflegungVerzehr {
  id: string;
  created_at: string;
  mitarbeiter_id: string;
  datum: string;
  typ: string;
  firma: VerpflegungFirma;
}

// ── Kunden-Links (Issue #71) ──

export type KundenLinkAktion =
  | 'dokument_hochladen'
  | 'unterschrift_auftrag'
  | 'unterschrift_abtretung'
  | 'unterschrift_mietwagen'
  | 'unterschrift_vollmacht'
  | 'unterschrift_anwaltsvollmacht';

export type KundenLinkVersandStatus = 'erstellt' | 'gesendet' | 'zugestellt' | 'fehler';

export interface KundenLink {
  id: string;
  token: string;
  passwort: string;
  akte_id: string | null;
  business_unit: string;
  kunde_name: string | null;
  kunde_telefon: string | null;
  kunde_email: string | null;
  kennzeichen: string | null;
  kanzlei_id: string | null;
  aktionen: KundenLinkAktion[];
  vorausgefuellte_felder: Record<string, any>;
  versand_kanal: string[];
  versand_status: KundenLinkVersandStatus;
  aufrufe: number;
  letzter_zugriff: string | null;
  erledigte_aktionen: string[];
  erstellt_von: string | null;
  gueltig_bis: string;
  ist_aktiv: boolean;
  created_at: string;
  updated_at: string;
}

// ── Kanzleien (Issue #139) ──

// ── Honorarvereinbarung-Template — Issue #373, Teil #314 ──
// Stammdaten für SV-Gutachten-Honorarvereinbarungen (BVSK, HUK, individuell …).
// `akten.honorarvereinbarung_template_id` referenziert hierhin; der PDF-Upload
// nach `storage_path` ist ein eigenes Sub-Issue (Voraussetzung).
export interface HonorarvereinbarungTemplate {
  id: string;
  slug: string;
  label: string;
  beschreibung: string | null;
  storage_path: string | null;
  ist_aktiv: boolean;
  sortierung: number;
  created_at: string;
  updated_at: string;
}

export interface Kanzlei {
  id: string;
  name: string;
  adresse: string | null;
  plz: string | null;
  ort: string | null;
  telefon: string | null;
  email: string | null;
  ist_aktiv: boolean;
  created_at: string;
  updated_at: string;
}

// ── Marken (Rechtsträger) — Issue #278, Teil #260 ──
// Stammdaten pro Marke inkl. rechtlicher Angaben (HRB, USt-ID, Bank) und
// Branding-Assets (Logo, Briefkopf, Footer). Referenziert von E-Mail- und
// PDF-Generator (eigene Folge-Issues).
export interface Marke {
  id: string;
  marken_name: string;
  rechtstraeger: string;
  betrieb_id: string | null;
  typ: string | null;
  business_unit: string | null;
  hrb_nr: string | null;
  ust_id: string | null;
  anschrift: string | null;
  iban: string | null;
  bic: string | null;
  logo_url: string | null;
  briefkopf_url: string | null;
  footer_disclaimer: string | null;
  absender_email: string | null;
  ist_aktiv: boolean;
  created_at: string;
  updated_at: string;
}

export interface KundenLinkDokument {
  id: string;
  link_id: string;
  name: string;
  dateityp: string | null;
  groesse_bytes: number | null;
  storage_pfad: string;
  kategorie: string | null;
  created_at: string;
}

// ── Poolfahrzeuge / GPS-Tracking (Issue #162, Teil #161) ──

export type FahrzeugNutzungsart =
  | 'einzelnutzer'
  | 'pool'
  | 'mietfahrzeug'
  | 'werkstattwagen';

export type FahrtenbuchMethode = 'digital_gps' | 'papier' | '1_prozent';

export type FahrtenbuchKategorie = 'dienstlich' | 'arbeitsweg' | 'privat';

export type NutzungsordnungBestaetigungKanal =
  | 'ui_klick'
  | 'unterschrift_pdf'
  | 'email_bestaetigung';

export interface PoolReservierung {
  id: string;
  fahrzeug_id: string;
  mitarbeiter_id: string;
  fahrer_mitarbeiter_id: string | null;
  beginn: string;
  ende: string;
  zweck: string;
  ziel: string | null;
  km_beginn: number | null;
  km_ende: number | null;
  dienstlich: boolean;
  schluesselausgabe_durch_id: string | null;
  schluesselausgabe_am: string | null;
  schadenbericht: string | null;
  abhol_foto_urls: string[] | null;
  abhol_tankstand: number | null;
  abhol_ladestand_prozent: number | null;
  rueckgabe_foto_urls: string[] | null;
  rueckgabe_tankstand: number | null;
  rueckgabe_ladestand_prozent: number | null;
  created_at: string;
  updated_at: string;
}

export interface FahrtenbuchEintrag {
  id: string;
  fahrzeug_id: string;
  fahrer_id: string;
  beginn_zeit: string;
  ende_zeit: string;
  beginn_ort: string | null;
  ende_ort: string | null;
  beginn_adresse: string | null;
  ende_adresse: string | null;
  km_gefahren: number;
  kategorie: FahrtenbuchKategorie;
  gps_route_geojson: unknown | null;
  gps_source: string | null;
  gps_fahrten_id: string | null;
  zweck: string | null;
  geschaeftspartner: string | null;
  created_at: string;
  updated_at: string;
}

export interface NutzungsordnungBestaetigung {
  id: string;
  fahrzeug_id: string;
  mitarbeiter_id: string;
  version: string;
  bestaetigt_am: string;
  bestaetigt_per: NutzungsordnungBestaetigungKanal;
  ip_adresse: string | null;
  user_agent: string | null;
  created_at: string;
}

// ── CRM Multi-Label + Timeline-Notizen (Issue #335) ──

export type CrmKontaktRolle =
  | 'kunde'
  | 'anwalt'
  | 'versicherung'
  | 'werkstatt'
  | 'sv-partner'
  | 'lieferant'
  | 'gegner'
  | 'zeuge';

export interface CrmKontaktLabel {
  id: string;
  kontakt_id: string;
  betrieb_id: string | null;
  marke_id: string | null;
  rolle: CrmKontaktRolle | string | null;
  aktiv: boolean;
  notiz: string | null;
  created_at: string;
}

export interface CrmKontaktNotiz {
  id: string;
  kontakt_id: string;
  betrieb_id: string | null;
  autor_id: string | null;
  inhalt: string;
  sichtbar_fuer_alle: boolean;
  created_at: string;
}

/** Sachbezugswert 2026 pro Mahlzeit (jaehrlich anpassbar) */
export const SACHBEZUGSWERT_PRO_TAG = 4.57;

// ── Werkstatt Auto-Match Kandidaten (Issue #328) ─────────────────────────────
// Shape of rows returned by the `match_werkstatt_akte` RPC / JSONB column.
export interface WerkstattAutoMatchKandidat {
  id: string;
  akten_nummer: string | null;
  akten_nr?: string | null;
  kunde_name?: string | null;
  kennzeichen?: string | null;
  score?: number | null;
}

// ── Nummernkreise (Issue #483 + #484 / Teil von #313) ──
export interface Nummernkreis {
  id: string;
  betrieb_id: string;
  marke_id: string | null;
  praefix: string;
  jahr: number;
  naechste_nummer: number;
  stellen: number;
  aktiv: boolean;
  created_at: string;
}

export type NummernkreisInsert = Omit<Nummernkreis, 'id' | 'created_at'>;
export type NummernkreisUpdate = Partial<Omit<Nummernkreis, 'id' | 'created_at'>>;

// ─── Akten-Fristen (Issue #651) ──────────────────────────────────────────────
export type AkteFristTyp =
  | 'wiedervorlage'
  | 'eskalation_mahnstufe'
  | 'verjaehrung_3jahre'
  | 'gerichtstermin'
  | 'eingang_sachstandsbericht'
  | 'rueckruf'
  | 'sonstiges';

export interface AkteFrist {
  id: string;
  akte_id: string;
  typ: AkteFristTyp;
  faellig_am: string;
  bemerkung: string | null;
  erinnert_am: string | null;
  erledigt_am: string | null;
  erledigt_von: string | null;
  created_at: string;
  created_by: string | null;
}

export type AkteFristInsert = Omit<AkteFrist, 'id' | 'created_at' | 'erledigt_am'>;
export type AkteFristUpdate = Partial<Omit<AkteFrist, 'id' | 'created_at'>>;

// ── Universal-Eingangskorb inbox_items (Issue #643 / Teil von #590) ──────────

export type InboxItemStatus = 'neu' | 'klassifiziert' | 'sortiert' | 'archiviert' | 'abgelehnt';

export type InboxQuelle =
  | 'mail'
  | 'scan'
  | 'upload'
  | 'drive_sync'
  | 'whatsapp'
  | 'fax'
  | 'manuell';

export type InboxKlassifizierung =
  | 'eingangsrechnung'
  | 'versicherungs_anschreiben'
  | 'versicherungs_abrechnung'
  | 'anwaltsschreiben'
  | 'gerichts_brief'
  | 'schadensmeldung'
  | 'gutachten_anforderung'
  | 'reparatur_kostenvoranschlag'
  | 'mahnung'
  | 'zulassungsbescheinigung_zb1'
  | 'zulassungsbescheinigung_zb2'
  | 'kaufvertrag_fahrzeug'
  | 'leasingvertrag'
  | 'versicherungspolice'
  | 'logo_branding'
  | 'mitarbeiter_dokument'
  | 'sonstiges';

export interface InboxItem {
  id: string;
  status: InboxItemStatus;
  eingangs_quelle: InboxQuelle | null;
  eingangs_datum: string;
  absender_email: string | null;
  absender_name: string | null;
  betreff: string | null;
  storage_path: string | null;
  pdf_url: string | null;
  mime_type: string | null;
  dateigroesse_bytes: number | null;
  thumbnail_url: string | null;
  ki_klassifizierung: InboxKlassifizierung | null;
  ki_konfidenz: number | null;
  ki_extracted_fields: Record<string, unknown> | null;
  vorgeschlagene_zielmodul: string | null;
  vorgeschlagene_ziel_id: string | null;
  vorgeschlagene_kategorie: string | null;
  sortiert_in_modul: string | null;
  sortiert_in_ziel_id: string | null;
  sortiert_am: string | null;
  sortiert_durch_user_id: string | null;
  bemerkung: string | null;
  created_at: string;
  updated_at: string;
}

export type InboxItemInsert = Omit<InboxItem, 'id' | 'created_at' | 'updated_at'>;
export type InboxItemUpdate = Partial<Omit<InboxItem, 'id' | 'created_at'>>;

// ── Leistungs-Katalog (Issue #368/#369) ──────────────────────────────────────

export interface LeistungsKatalogItem {
  id: string;
  betrieb_id: string;
  marke_id: string | null;
  typ: string;
  bezeichnung: string;
  einzelpreis: number;
  einheit: string | null;
  beschreibung: string | null;
  ist_aktiv: boolean;
  created_at: string;
  updated_at: string;
}

// ── Branding Assets (Issue #645) ──────────────────────────────────────────────

export interface BrandingAsset {
  id: string;
  slug: string;
  storage_path: string;
  public_url: string | null;
  mime_type: string | null;
  original_inbox_item_id: string | null;
  erstellt_von_user_id: string | null;
  created_at: string;
}

// ─── Signature Requests (Issue #649) ─────────────────────────────────────────

export type SignatureRequestStatus = 'ausstehend' | 'unterschrieben' | 'abgelaufen';

export interface SignatureRequest {
  id: string;
  akte_id: string;
  mietwagen_akte_id: string;
  recipient_email: string;
  token: string;
  status: SignatureRequestStatus;
  vertrag_pdf_url: string | null;
  signature_data: string | null;
  created_at: string;
  unterschrieben_am: string | null;
}

export type SignatureRequestInsert = Omit<SignatureRequest, 'id' | 'created_at' | 'token'>;
export type SignatureRequestUpdate = Partial<Omit<SignatureRequest, 'id' | 'created_at' | 'token'>>;

// ── Ladekostenzuschuss (Issue #200) ──

export interface Ladekostenzuschuss {
  id: string;
  mitarbeiter_id: string;
  fahrzeug_id: string;
  hat_arbeitsplatz_ladung: boolean;
  pauschale_eur: number;
  gueltig_ab: string;
  gueltig_bis: string | null;
  created_at: string;
  updated_at: string;
}
